<div *ngIf="selectedForexOption !== ApCurrency.UNKNOWN" class="select_trigger_cont">
	<button class="fb-product-currency"
			(click)="forexShow = !forexShow">
		<span class="sort_text uppercase">{{selectedForexOption}}</span>
		<span *ngIf="!forexShow" class="material-symbols-outlined">
				arrow_drop_down
		</span>

		<span *ngIf="forexShow" class="material-symbols-outlined">
				arrow_drop_up
		</span>

	</button>

	<div class="select" [@enterAnimation] *ngIf="forexShow">
		<div *ngFor="let option of currencyList"
			 class="option uppercase {{selectedForexOption===option.name.toLowerCase()?'active_sort_option':''}}"
			 (click)="setForex(option.name.toLowerCase())">
			{{option.name}}
		</div>
	</div>
</div>
